export default {
  "content": "<path d=\"M201.14 64L256 32l54.86 32M256 32v80M310.86 448L256 480l-54.86-32M256 480v-80M64 207.51V144l53.15-31.51M64 144l67.29 40M448 304.49V368l-53.15 31.51M448 368l-67.29-40M117.15 400L64 368v-63.51M64 368l66.64-40M394.85 112.49L448 144v63.51M448 144l-67.29 40M256 320v-64l54.86-32M256 256l-54.86-32\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};